import { useState } from 'react';
import { commentSpotlight, trendingTopics } from '@/mocks/home';

const trendIcon: Record<string, { icon: string; cls: string }> = {
  up: { icon: 'ri-arrow-up-line', cls: 'text-primary-500' },
  down: { icon: 'ri-arrow-down-line', cls: 'text-secondary-600' },
  flat: { icon: 'ri-subtract-line', cls: 'text-foreground-400' },
};

export default function CommentBoard() {
  const [liked, setLiked] = useState<Record<string, boolean>>({});

  const toggleLike = (user: string) => {
    setLiked((prev) => ({ ...prev, [user]: !prev[user] }));
  };

  return (
    <section id="trending" className="w-full border-y bg-background-100/70 hairline">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-16 lg:px-10">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-8">
          <div className="lg:col-span-7">
            <span className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.18em] text-primary-600">
              <i className="ri-chat-smile-3-line text-sm"></i>
              FROM THE FLOOR
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
              评论区里的高赞发言
            </h2>
            <p className="mt-2 max-w-xl text-sm leading-relaxed text-foreground-600">
              爱黑料网论坛区每天冒出新面孔，这几条是近两天被顶得最高、也最能把话题接住的留言。
            </p>

            <div className="mt-6 flex flex-col gap-4">
              {commentSpotlight.map((item) => (
                <article
                  key={item.user}
                  className="flex gap-3.5 rounded-lg border bg-background-50 p-4 md:gap-4 md:p-5 hairline"
                >
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-accent-100 font-heading text-base font-black text-accent-900">
                    {item.initial}
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                      <span className="text-sm font-bold text-foreground-950">{item.user}</span>
                      <span className="rounded bg-secondary-100 px-2 py-0.5 text-[11px] font-semibold text-secondary-900">
                        {item.level}
                      </span>
                      <span className="text-xs text-foreground-500">
                        围绕「{item.topic}」
                      </span>
                    </div>
                    <p className="mt-2 text-sm leading-relaxed text-foreground-700">
                      {item.content}
                    </p>
                    <div className="mt-3 flex items-center gap-5 text-xs">
                      <button
                        type="button"
                        onClick={() => toggleLike(item.user)}
                        className={`flex cursor-pointer items-center gap-1.5 font-semibold transition-colors ${
                          liked[item.user] ? 'text-primary-600' : 'text-foreground-500 hover:text-primary-600'
                        }`}
                      >
                        <i className={`${liked[item.user] ? 'ri-heart-3-fill' : 'ri-heart-3-line'} text-sm`}></i>
                        {item.likes}
                      </button>
                      <button
                        type="button"
                        className="flex cursor-pointer items-center gap-1.5 font-semibold text-foreground-500 transition-colors hover:text-foreground-900"
                      >
                        <i className="ri-reply-line text-sm"></i>
                        回复
                      </button>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>

          <aside className="lg:col-span-5">
            <div className="rounded-lg border bg-background-50 p-5 md:p-6 hairline">
              <div className="flex items-center justify-between">
                <h3 className="font-heading text-lg font-black text-foreground-950">
                  热议风向榜
                </h3>
                <span className="flex items-center gap-1.5 rounded-full bg-primary-100 px-2.5 py-1 text-[11px] font-bold text-primary-800">
                  <i className="ri-live-line text-sm"></i>
                  实时
                </span>
              </div>
              <p className="mt-2 text-xs leading-relaxed text-foreground-500">
                按讨论量排序，看看此刻大家都在围观的现场。
              </p>

              <ul className="mt-5 flex flex-col">
                {trendingTopics.map((topic, idx) => {
                  const trend = trendIcon[topic.trend] ?? trendIcon.flat;
                  return (
                    <li key={topic.label}>
                      <button
                        type="button"
                        className="flex w-full cursor-pointer items-center gap-3 border-b border-dashed py-3 text-left transition-colors hairline hover:text-primary-600"
                      >
                        <span className="w-5 shrink-0 font-heading text-sm font-black text-background-400">
                          {idx + 1}
                        </span>
                        <span className="min-w-0 flex-1 truncate text-sm font-semibold text-foreground-800">
                          {topic.label}
                        </span>
                        <span className="shrink-0 text-xs font-semibold text-foreground-500">
                          {topic.heat}
                        </span>
                        <i className={`${trend.icon} text-sm ${trend.cls}`}></i>
                      </button>
                    </li>
                  );
                })}
              </ul>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}